import React from "react";
import { Col, Row } from "react-bootstrap";
import AudioInput from "../../../atoms/InputController/General/Audio-input/AudioInput";
import UploadRecordingButton from "../../../atoms/Buttons/Upload-Recording/Upload-RecordingButton";
import LabelController from "../../../atoms/Label/LabelController";
import Loader from "../../../atoms/Loader/Loader";
import LoaderHome from "../../../atoms/Loader-home/Loader-home";

interface FileMetaProps {
  name?: string;
  size?: number;
}

interface AddRecordingSectionProps {
  newLeadContent: {
    record?: {
      label: string;
    };
    [key: string]: any; // Allow other properties
  };
  recordUrl?: FileMetaProps;
  handleRecording: (file: File) => void;
  onDeleteRecording?: () => void;
  hasFile?: boolean;
  isUploading?: boolean;
  [key: string]: any; // Allow other props
}

const getFileMeta = ({ name, size }: FileMetaProps, onDelete?: () => void) => {
  if (!name) return null;

  const sizeKb = Math.round((size || 0) / 1024);
  const maxLength = 40;
  const prettyName =
    name.length > maxLength ? `${name.slice(0, 28)}…${name.slice(-10)}` : name;

  return (
    <div className="recording-file-meta">
      <span className="label">Selected file:</span>
      <span className="name" title={name}>
        {prettyName}
      </span>
      <span className="size">({sizeKb} KB)</span>
      {onDelete && (
        <button
          className="recording-delete-btn"
          type="button"
          title="Remove file"
          onClick={(e) => {
            e.stopPropagation();
            onDelete();
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="12"
            height="12"
            viewBox="0 0 24 24"
            fill="none"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <polyline points="3 6 5 6 21 6" />
            <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
            <path d="M10 11v6" />
            <path d="M14 11v6" />
            <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
          </svg>
        </button>
      )}
    </div>
  );
};

const AddRecordingSection: React.FC<AddRecordingSectionProps> = ({
  newLeadContent,
  recordUrl,
  handleRecording,
  onDeleteRecording,
  hasFile,
  isUploading,
}) => {
  // Safely get the label with a default value
  const label = newLeadContent.record
    ? newLeadContent.record.label
    : "Recording";

  return (
    <div className="box-container">
      <Row className="add-recording-section">
        <Col xs={12}>
          <LabelController label={label} />
        </Col>
        {isUploading && (
          <Col sm={12}>
            <LoaderHome />
          </Col>
        )}
        {!isUploading && (
          <Col sm={6}>
            <UploadRecordingButton
              handleRecording={handleRecording}
              hasFile={hasFile}
            />
            {getFileMeta(recordUrl || {}, onDeleteRecording)}
          </Col>
        )}
        <Col sm={6}>
          <AudioInput recordUrl={recordUrl} />
        </Col>
      </Row>
    </div>
  );
};

export default AddRecordingSection;
